<div class="swicus-intercept">
  <h3>We've noticed you're already using another SolarWinds Cloud Product</h3>
  <p>
    <span class="long-form">No need to sign up for an additional account, </span>
    <span class="short-form-start">logging in</span> in with your existing
    credentials will give you instant access to
    <a href="https://www.appoptics.com">AppOptics</a>,
    <a href="https://www.loggly.com/">Loggly</a>,
    <a href="https://www.papertrailapp.com">Papertrail</a>,
    and <a href="https://www.pingdom.com/">Pingdom</a>!
  </p>
  <p class="swicus-intercept__cta">
    <a class="btn-cta mod-primary" href="/login">
      Log In
    </a>
    <a class="btn-cta" href="https://www.papertrail.com/plans/" data-swicus-intercept-ignore>
      Sign Up with a different email address
    </a>
  </p>
</div>
